//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'GFR_CKD_EPI',
  data () {
    return {
      form: {
        age:'',
        scr:'',
        gender:'0',

      },
      hasScore: false,
      disabled: false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.res2='--'
        return '--'
      } else {
        let k,d,a
        k = form.gender == '1' ? 0.7 : 0.9
        d = form.gender == '1' ? 1.012 : 1
        a = form.gender == '1' ? (form.scr / 88.4 <= 0.7 ? -0.241 : -1.2) : (form.scr / 88.4 <= 0.9 ? -0.302 : -1.2)
        let result = 142 * Math.pow(form.scr / 88.4 / k, a) * Math.pow(0.9938, form.age) * d
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Urology/GFR_CKD_EPI.vue